import { Outlet, Link } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 text-gray-900 font-sans antialiased">
      <Outlet /> 
	  {/* Footer - Updated with Link components */}
      <footer className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-8 mt-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <img src="/HunterFortress_Logo_Shield_Crosshairs_Optimized.png" alt="Logo" className="h-10 mr-3" />
            <span className="text-xl font-bold">HunterFortress</span>
          </div>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link to="/contact" className="hover:text-blue-300 transition">Contact</Link>
            <Link to="/storepal" className="hover:text-blue-300 transition">StorePal</Link>
            <Link to="/terms" className="hover:text-blue-300 transition">Terms</Link>
            <Link to="/privacy" className="hover:text-blue-300 transition">Privacy</Link>
            <Link to="/blog" className="hover:text-blue-300 transition">Blog</Link>
          </div>
        </div>
        <div className="text-center mt-6 pt-6 border-t border-blue-700">
          <p>&copy; 2025 HunterFortress. All rights reserved.</p>
        </div>
      </footer>
	  {/* This renders the matched route */}
    </div>
  );
}
